export interface Product {
  name: string;
  description: string;
}

export interface Job {
  title: string;
  company: string;
  // Maps each company name (split on " + ") to its URL
  links?: Record<string, string>;
  period: string;
  description: string;
  products?: Product[];
}

export const jobHistory: Job[] = [
  {
    title: "Lead Dev",
    company: "Stakwork + Sphinx Chat",
    links: {
      "Stakwork": "https://jobs.stakwork.com/workers",
      "Sphinx Chat": "https://www.sphinx.chat/",
    },
    period: "2020 - present",
    description: "",
    products: [
      {
        name: "Hive",
        description: "AI-powered software factory with agentic knowledge bases.",
      },
      {
        name: "Sphinx Chat",
        description:
          "P2P encrypted chat protocol and app built on Lightning and Bitcoin. Rust, React Native, Typescript, Golang, MQTT, Swift, Kotlin.",
      },
      {
        name: "Stakwork",
        description: "Workflow automation blending AI and micro-tasks for humans.",
      },
    ],
  },
  {
    title: "Bitcoin Developer",
    company: "Portal to Bitcoin",
    links: {
      "Portal to Bitcoin": "https://portaltobitcoin.com/",
    },
    period: "2024 - 2025",
    description:
      "Atomic swaps between Bitcoin L1, ETH, and SOL. Rust, React, Next.js, Typescript, EVM, SVM, Bitcion miniscript, Hardware wallet integrations.",
  },
  {
    title: "Crypto Bridge Developer",
    company: "Tidefi",
    links: {
      "Tidefi": "https://tidefi-official.medium.com/",
    },
    period: "2022 - 2023",
    description:
      "Cross chain bridges for Bitcoin and Ethereum. Rust, React, Tauri, Bitcoin Script, Solidity.",
  },
  {
    title: "Web Technologies Instructor",
    company: "University of Washington",
    links: {
      "University of Washington": "https://www.hcde.washington.edu/students/design-tools-resources/frontend-web",
    },
    period: "2019 - 2021",
    description:
      "Developing curriculum and teaching modern web development methodologies (HCDE438). React, Node.js, ES6, HTML5, CSS3, databases, hosting.",
  },
  {
    title: "Lead Software Engineer",
    company: "H2H Group",
    period: "2018 - 2020",
    description:
      "Architect and lead developer of secure and scalable software for IoT device management and big data analytics, used by supply chain and logistics providers. Golang, React, React-Native, C, MQTT, microservices.",
  },
  {
    title: "Full Stack Web Developer",
    company: "Lingk.io",
    links: {
      "Lingk.io": "https://www.lingk.io/",
    },
    period: "2016 - 2018",
    description:
      "Design and development of a data integration and analytics toolset for universities, using React, Node.js, Golang, AWS, Docker, Elasticsearch, Postgres, Oauth2.",
  },
  {
    title: "Web Developer",
    company: "Freelance",
    period: "2014 - present",
    description:
      "Developing websites and web applications for a variety of businesses and clients, using technologies such as React, React Native, Node.js, Typescript, Golang, Rust, Docker.",
  },
];
